"use strict";

const Misc = () => {
    const init = () => {
        $(function() {
            var $buttons = $('.js-load-more-button');
            if ($buttons.length > 0) {
                $buttons.on('click', function(){
                    var $button = $(this);
                    var $content = $button.siblings('.js-load-more-content');
                    $content.css('height', 'auto');
                    var height = $content.outerHeight();
                    $content.css('height', '');
                    $content.animate({'height': height+'px'}, function(){
                        $content.css('height', 'auto');
                        $button.remove();
                    });
                });
            }

            var $buttons = $('.js-view-all-button');
            if ($buttons.length > 0) {
                $buttons.on('click', function(){
                    var $button = $(this);
                    var $content = $button.parents('.js-view-all-content');
                    $content.addClass('loaded');
                    $button.remove();
                });
            }

            var $scrollToTop = $('.js-scroll-to-top');
            if ($scrollToTop.length > 0) {
                $scrollToTop.on('click', function(){
                    $('html, body').animate({
                        scrollTop: 0
                    }, 100);
                });

                $(window).on('scroll', function(){
                    if($(this).scrollTop() > $(window).height()){
                        $scrollToTop.addClass('active');
                    }else{
                        $scrollToTop.removeClass('active');
                    }
                });
            }

            var $scrollTo = $('.js-scroll-to');
            if ($scrollTo.length > 0) {
                $scrollTo.on('click', function(){
                    let $target = $($(this).data('target'));
                    if($target.length){

                        $('html, body').animate({
                            scrollTop: $target.offset().top
                        }, 100);
                    }
                });
            }

            var $columns = $('.js-hover-column');
            if ($columns.length > 0) {
                var $images = $('.js-hover-image');
                $columns.on('mouseenter', function(){
                    var $this = $(this);
                    $images.removeClass('active');
                    $images.filter('[data-id="'+$this.data('id')+'"]').addClass('active');
                    $this.find('.hidden').stop().slideDown({
                        start: function () {
                            $(this).css('display', 'flex')
                        }
                    });
                });
                $columns.on('mouseleave', function(){
                    var $this = $(this);
                    $this.find('.hidden').stop().slideUp();
                });
            }

            var $promoPackages = $('.js-hlpromo-packages');
            if ($promoPackages.length > 0) {
                $promoPackages.find('.js-hlpromo-filter-button').on('click', function(){
                    var $parent = $(this).parents('.js-hlpromo-packages');
                    var $form = $parent.find('.js-hlpromo-form');
                    $form.find('input[name="regions"]').val($(this).data('regions'));
                    $form.find('input[name="storeys"]').val($(this).data('storeys'));
                    $form.find('input[name="title"]').val($(this).data('title'));
                    $form.find('.ajax-submit').trigger('click');
                    $parent.find('.js-hlpromo-filters').show();
                });

                $promoPackages.each(function(){
                    var $promoPackage = $(this);
                    var $form = $promoPackage.find('.js-hlpromo-form');
                    var $filters = $promoPackage.find('.js-hlpromo-filters');
                    var $radios = $filters.find('.js-radio');
                    var $dropdowns = $filters.find('.nice-select');
                    var $advancedToggle = $filters.find('.js-filters-advanced-toggle');

                    $radios.on('click', function(e){
                        e.preventDefault();
                        var $input = $(this).find('input');
                        if($input.is(':checked')){
                            $input.prop('checked', false);
                            $form.find('[name="'+$(this).data('name')+'"]').val('');
                        }else{
                            $radios.filter('[data-name="'+$(this).data('name')+'"]').find('input').prop('checked', false);
                            $input.prop('checked', true);
                            $form.find('[name="'+$(this).data('name')+'"]').val($(this).find('input').val());
                        }
                        $form.find('[name="page"]').val(1);
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $dropdowns.on('change', function(){
                        $form.find('[name="'+$(this).attr('name')+'"]').val($(this).val());
                        $form.find('[name="page"]').val(1);
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $advancedToggle.on('click', function(){
                        let $this = $(this);
                        if($this.hasClass('active')){
                            $this.removeClass('active');
                            $filters.find('.js-filters-advanced').slideUp();
                        }else{
                            $this.addClass('active');
                            $filters.find('.js-filters-advanced').slideDown();
                        }
                    });
                });
            }
        });
    };

    return {
        init:init
    };
};

export default Misc;